module.exports = __webpack_public_path__ + "img/ICON_butom_arrow.28fe0745.svg";